import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../context/UserContext";
import useQuery from "../../../../hooks/useQuery";
import {
  getLatestNutritionRiskAssessmentAPI,
  getNutritionistInspectionAPI,
  getPatientDietItemsApi,
} from "../../../../services/nutritionist.services";
import DietView from "./DietView";
import NurtritionistDietChart from "./NurtritionistDietChart";
import NoDataPage from "../../../NoDataPages/NoDataPage";
import dietImage from "../../../../assets/images/nurseIcons/diet.svg";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";
import { Col, Row } from "antd";
import { getCookie } from "../../../../helpers/localStorage";
import { Role } from "../../../../constants/defaultKeys";
import useIsMobile from "../../../../hooks/useIsMobile";
import "./DietView.css";
const NutritionistDiet = ({ patientData }) => {
  const isMobile = useIsMobile();
  const { userDetails } = useContext(UserContext);
  const params = useQuery();
  const [dietData, setDietData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dietDetails, setDietDetails] = useState(null);

  const defaultRole = userDetails?.currRole || getCookie(Role);
  const role = defaultRole.toLowerCase()?.replaceAll("_", "-");

  const refreshDietData = () => {
    setRefresh(!refresh);
  };

  useEffect(() => {
    getPatientDietItemsApi(params?.patient)
      .then((res) => {
        setDietData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [refresh]);

  function orderNutritionalRecommendations(recommendations) {
    const desiredOrder = [
      "calories",
      "protein",
      "carbohydrates",
      "sodium",
      "potassium",
    ];

    return Object.fromEntries(
      desiredOrder?.map((key) => [key, recommendations[key]])
    );
  }
  useEffect(() => {
    if (patientData?.nutrition_risk_assessment?.length > 0) {
      getLatestNutritionRiskAssessmentAPI(params?.patient)
        .then((res) => {
          const diet =
            res?.data?.data?.functional_diagnosis?.diet_details?.diet || "";
          setDietDetails((prev) => ({
            ...prev,
            dietType: diet?.charAt(0)?.toUpperCase() + diet?.slice(1),
            otherSpecifications:
              res?.data?.data?.functional_diagnosis?.other_specifications,
            nutritional_recommendations: orderNutritionalRecommendations(
              res?.data?.data?.functional_diagnosis
                ?.nutritional_recommendations ?? {}
            ),
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (patientData?.nutrition_initial_assessment) {
      getNutritionistInspectionAPI(patientData?.nutrition_initial_assessment)
        .then((res) => {
          const ia = res?.data?.data;
          const diet = res?.data?.data?.diet_advice?.diet_details?.diet || "";
          setDietDetails((prev) => ({
            ...prev,
            ia: {
              dietType: diet?.charAt(0)?.toUpperCase() + diet?.slice(1),
              otherSpecifications: ia?.diet_advice?.other_specifications,
              nutritional_recommendations: orderNutritionalRecommendations(
                ia?.diet_advice?.nutritional_recommendations ?? {}
              ),
            },
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [params?.patient, patientData?.nutrition_initial_assessment]);

  return (
    <div className="diet-tab-root">
      {loading ? (
        <LoadingIndicator message={"Loading diet data, please wait..."} />
      ) : (
        <>
          {dietData && Object.keys(dietData?.slots).length !== 0 ? (
            <DietView
              dietData={dietData}
              refresh={refreshDietData}
              dietDetails={dietDetails}
            />
          ) : role === "nutritionist" ? (
            <NurtritionistDietChart
              diet={dietData}
              refresh={refreshDietData}
              dietDetails={dietDetails}
            />
          ) : (
            <Row
              className="diet-tab-empty"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: isMobile ? "50vh" : "80vh",
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                <NoDataPage
                  title="No Diet Found"
                  subtitle="It looks like there are no diets at the moment."
                  image={dietImage}
                />
              </Col>
            </Row>
          )}
        </>
      )}
    </div>
  );
};

export default NutritionistDiet;
